export default __webpack_public_path__ + "static/media/314.33494ee3.png";